<template>
    <div class="js_rank">
        <Sticky>
            <div class="header">
                <div class="tabs">
                    <div :class="[active==item.id?'active':'','tab']" @click="active = item.id" v-for="(item,index) in tablist">{{ item.name }}</div>
                </div>
            </div>
        </Sticky>
        <div class="main">
            <div class="myinfo">
                <div>
                    <img class="myavatar" :src="myinfo.avatarurl" />
                    <div class="myrank">
                        <div>{{ myinfo.nickname }}</div>
                        <div >
                            <template v-if="+myinfo.rank > 0">第 <span>{{ myinfo.rank }}</span> 名</template>
                            <template v-else>暂无排名</template>
                        </div>
                    </div>
       
                </div>
                <div>
                    <span>{{myinfo.totalpoint||'-'}}</span>  步
                </div>
            </div>
            <List
            style="color:#FFF;"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="init"
            >
                <div class="rank-list">
                    <CellGroup style="border-radius:.16rem" v-if="rankList.length" :border="false">
                    <Cell v-for="item in rankList" :key="item.id" center  class="rank">
                        <div slot="title">{{item.userInfo.name||item.userInfo.nickname}}</div>
                        <div slot="icon" class="rank_icon">
                            <template v-if="item.rank <= 3">
                                <img src="@/assets/img/rank/first.png" :alt="item.rank" v-if="item.rank == 1" />
                                <img src="@/assets/img/rank/second.png" :alt="item.rank" v-if="item.rank == 2" />
                                <img src="@/assets/img/rank/third.png" :alt="item.rank" v-if="item.rank == 3" />
                            </template>

                            <span v-else>{{ item.rank }}</span>
                            <VanImage :src="item.userInfo.avatarurl" />
                        </div>
                        <!-- <div
                        slot="label"
                        v-if="item.create_time"
                        >{{ (systime - item.create_time) | diffentTime(item.create_time) }}</div> -->


                        <span> {{ item.totalsteps*1 }}</span>

                    </Cell>
                    </CellGroup>
                    <Empty
                    style="background: #fff;min-height: 6rem;border-radius:.16rem"
                    v-else
                    description="暂无数据"
                    />
                </div>
            </List>
        </div>
    </div>
</template>

<script>
import "./index.less"
import { Empty, Panel, Cell, CellGroup, Image, List, Row, Col, Popup, Sticky } from "vant";
export default {
    components: {
        Empty,
        Panel,
        Cell,
        CellGroup,
        List,
        VanImage: Image,
        Row,
        Col,
        Popup,Sticky
    },
    data() {
        return {
            page: 1,
            loading: false,
            finished: false,
            activity_id: this.$route.params.activity_id,
            tablist: [
                {
                    id: 1,
                    name: '新就业形态组'
                },{
                    id: 2,
                    name: '大众组'
                }
            ],
            active: 1,
            myinfo: {},
            rankList: []
        }
    },
    watch: {
        active(newvalue, oldvalue) {
            this.page = 1
            this.loading = false
            this.finished = false
            this.init()             
        },
    },
    methods: {
        init() {
            this.$api.activity
            .stepsRank({
                type: this.active,
                activity_id: this.activity_id,
                page: this.page
            })
            .then((res) => {
                if (+res.status !== 200) {
                this.finished = true;
                return;
                }
                this.systime = res.sys_time;
                this.loading = false;
                let {
                list,
                page,
                pages,
                my
                } = res.data;
                this.myinfo = my;
                this.rankList = list;

                let t = null

                this.rankList.forEach((item, index) => {
                    if(t == null){
                        t =  item;
                        t.rank = index+1;
                    }else{
                        var n = item;
                        if(n.totalsteps*1 == t.totalsteps*1){
                            n.rank = t.rank;
                        }else{
                            n.rank = index+1;
                        }
                        t = n;
                    }
                })
                this.finished = true;
            });
        }
    },
}
</script>